module.exports = __webpack_public_path__ + "static/media/dyer_otero.d6b6ad8a.jpg";